import Image1 from "./ezgif-3-a9ad3b7e5b.jpg";
import Image2 from "./ezgif-3-fbe9ceb961.jpg";
import Image3 from "./ezgif-3-18f17d5d7f.jpg";
import Image4 from "./ezgif-3-89407dd20c.jpg";
import Image5 from "./ezgif-3-c7d58fcf9c.jpg";
import Image6 from "./ezgif-3-1b25dd1ee8.jpg";
import Image7 from "./ezgif-3-18c0e9e8a9.jpg";
import Image8 from "./ezgif-3-ac1c11d7d7.jpg";
import Image9 from "./ezgif-3-c1883c95c8.jpg";
import Image10 from "./ezgif-3-175308e748.jpg";
import Image11 from "./ezgif-3-046009caa8.jpg";
import Image12 from "./ezgif-3-1455eaf075.jpg";

export const allImages = [
  Image1,
  Image2,
  Image3,
  Image4,
  Image5,
  Image6,
  Image7,
  Image8,
  Image9,
  Image10,
  Image11,
  Image12,
];
